import { receiveFilter } from '@/pages/player/playerSlice'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from './useRedux'
import { playerSelector } from '@/pages/player/selectors'
import { userSelector } from '@/pages/user/selectors'

export function useReceivePlayerFilter() {
  const dispatch = useAppDispatch()
  const { user } = useAppSelector(userSelector)
  const { filter: filterPlayer } = useAppSelector(playerSelector)

  useEffect(() => {
    if (user) {
      dispatch(
        receiveFilter({ ...filterPlayer, lat: user?.addresses?.[0]?.latitude, lng: user?.addresses?.[0]?.longitude })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dispatch])
}
